import { render, staticRenderFns } from "./RuleActionsAdd.vue?vue&type=template&id=8669f95c&scoped=true&"
import script from "./RuleActionsAdd.vue?vue&type=script&lang=js&"
export * from "./RuleActionsAdd.vue?vue&type=script&lang=js&"
import style0 from "./RuleActionsAdd.vue?vue&type=style&index=0&id=8669f95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8669f95c",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTime from 'quasar/src/components/time/QTime.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QSelect,QBtn,QToggle,QInput,QDialog,QDate,QTime});qInstall(component, 'directives', {ClosePopup});
